import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';

export const expenseApprovaldetails = createAsyncThunk(
  'expenseApprovaldetails',
  async (_, { rejectWithValue }) => {
    try {
      const employeeId = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const res = await axios.get(`/GetExpenseApproval`, {
        params: { employeeid: employeeId },
      });

      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const expenseWisedetails = createAsyncThunk(
  'expenseWisedetails',
  async (Expense_ID, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/GetExpenseViewAllDetails`, {
        params: { Expense_ID },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const expenseSundrydetails = createAsyncThunk(
  'expenseSundrydetails',
  async (Expense_ID, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/GetExpenseApprovalSundry`, {
        params: { Expense_ID },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const expenseAttachment = createAsyncThunk(
  'expenseAttachment',
  async (expenseId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/expenseApprovalAttachment`, {
        params: { expenseId },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const expenseApprovalDraft = createAsyncThunk(
  'expenseApprovalDraft',
  async (draft, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post('/expenseDraftSubmit', draft);
      return successResponseParser(response);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const expenseApprovalSubmit = createAsyncThunk(
  'expenseApprovalSubmit',
  async (SubmitData, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post('/expenseApprovalSubmit', SubmitData);
      console.log('expenseApprovalSubmit', response);
      return successResponseParser(response);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const expenseApprovalPopup = createAsyncThunk(
  'expenseApprovalPopup',
  async ({ Emp_id, ActivityDate }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/GetExpenseApprovalPopup`, {
        params: { Emp_id, ActivityDate },
      });

      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

const expenseApproval = createSlice({
  name: 'expenseApproval',
  initialState: {
    isLoading: false,
    data: [],
    details: [],
    sundry: [],
    attachmentdata: [],
    Popdata: [],
    successMessage: '',
    apiError: '',
  },
  reducers: {
    updateExpenseDetails: (state, action) => {
      state.details = action.payload;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = '';
    },
    resetEmployeeData: (state, action) => {
      state.Popdata = action.payload; // Reset data
    },
  },

  extraReducers: (builder) => {
    builder.addCase(expenseApprovaldetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseApprovaldetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(expenseApprovaldetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.data = null;
    });

    builder.addCase(expenseWisedetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseWisedetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.details = action.payload;
    });
    builder.addCase(expenseWisedetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.details = null;
    });

    builder.addCase(expenseSundrydetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseSundrydetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.sundry = action.payload;
    });
    builder.addCase(expenseSundrydetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.sundry = null;
    });

    builder.addCase(expenseAttachment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(expenseAttachment.fulfilled, (state, action) => {
      state.isLoading = false;
      state.attachmentdata = action.payload;
    });
    builder.addCase(expenseAttachment.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.sundry = null;
    });

    builder.addCase(expenseApprovalDraft.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.successMessage = '';
    });
    builder.addCase(expenseApprovalDraft.fulfilled, (state, action) => {
      state.isLoading = false;
      state.draft = action.payload;
      state.successMessage = action.payload?.result;
    });
    builder.addCase(expenseApprovalDraft.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.draft = null;
      state.isLoading = false;
    });

    builder.addCase(expenseApprovalSubmit.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.successMessage = '';
    });
    builder.addCase(expenseApprovalSubmit.fulfilled, (state, action) => {
      state.isLoading = false;
      state.SubmitData = action.payload;
      state.successMessage = action.payload?.result;
      state.success = true;
    });
    builder.addCase(expenseApprovalSubmit.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.SubmitData = null;
      state.isLoading = false;
    });

    builder.addCase(expenseApprovalPopup.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.successMessage = '';
    });
    builder.addCase(expenseApprovalPopup.fulfilled, (state, action) => {
      state.isLoading = false;
      state.Popdata = action.payload;
      state.success = true;
    });
    builder.addCase(expenseApprovalPopup.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.Popdata = null;
      state.isLoading = false;
    });
  },
});

export const { updateExpenseDetails, clearSuccessMessage, resetEmployeeData } =
  expenseApproval.actions;
export default expenseApproval.reducer;
